// ----------------------------------------------------------------------------
// Auto-generated file. Do not edit directly. Changes may be overwritten.
// Run 'npm run codegen:lookup-tables' to regenerate.
// ----------------------------------------------------------------------------

// Lookup table definitions, collected from OpenAPI specs.
// ----------------------------------------------------------------------------

const def = Object.freeze({
  SifZivalStatus: {
    path: "sif/zivalStatus",
    name: "Zival Status",
    description:
      "[sif.zival_status] Šifrant z vrednostmi za status živali (Aktivna, Izločena).",
  },
  SifZivalSekundarniStatus: {
    path: "sif/zivalSekundarniStatus",
    name: "Zival Sekundarni Status",
    description:
      "[sif.zival_sekundarni_status] Šifrant različnih možnosti za sekundarne statuse živali.",
  },
  SifZivalRazvojniStadij: {
    path: "sif/zivalRazvojniStadij",
    name: "Zival Razvojni Stadij",
    description:
      "[sif.zival_razvojni_stadij] Šifrant z vrednostmi za razvojni stadij živali (Mladič, Odrasel).",
  },
  SifVzrokIzlocitve: {
    path: "sif/vzrokIzlocitve",
    name: "Vzrok Izlocitve",
    description: "[sif.vzrok_izlocitve] Šifrant vzrokov za izločitev živali.",
  },
  SifVrstaPreiskave: {
    path: "sif/vrstaPreiskave",
    name: "Vrsta Preiskave",
    description:
      "[sif.vrsta_preiskave] Šifrant različnih možnosti za vrsto preiskav vzorcev.",
  },
  SifVrstaOcenjevanja: {
    path: "sif/vrstaOcenjevanja",
    name: "Vrsta Ocenjevanja",
    description:
      "[sif.vrsta_ocenjevanja] Šifrant različnih vrst ocenjevalnih listov.",
  },
  SifVrstaLabVzorca: {
    path: "sif/vrstaLabVzorca",
    name: "Vrsta Lab Vzorca",
    description:
      "[sif.vrsta_lab_vzorca] Šifrant z zalogo vrednosti za nabor vrste vzorca.",
  },
  SifVrstaDatoteke: {
    path: "sif/vrstaDatoteke",
    name: "Vrsta Datoteke",
    description:
      "[sif.vrsta_datoteke] Šifrant, ki vsebuje zalogo vrednosti za vrsto datoteke (priponke), ki jo določa uporabnik.",
  },
  SifVirPodatkov: {
    path: "sif/virPodatkov",
    name: "Vir Podatkov",
    description: "[sif.vir_podatkov] Šifrant različnih možnih virov podatkov.",
  },
  SifUsmeritevReje: {
    path: "sif/usmeritevReje",
    name: "Usmeritev Reje",
    description:
      "[sif.usmeritev_reje] Šifrant z vrednostmi za usmeritev reje (zajeto ob vpisu rejca v rejni program).",
  },
  SifUporabnostSemena: {
    path: "sif/uporabnostSemena",
    name: "Uporabnost Semena",
    description:
      "[sif.uporabnost_semena] Šifrant z zalogo vrednosti, ki opisujejo uporabnost semena.",
  },
  SifTrenutnaLokacijaTipVzrocniZapis: {
    path: "sif/trenutnaLokacijaTipVzrocniZapis",
    name: "Trenutna Lokacija Tip Vzrocni Zapis",
    description:
      "[sif.trenutna_lokacija_tip_vzrocni_zapis] Šifrant možnih vzročnih zapisov (Premik, Rosjtvo...).",
  },
  SifTpStatusOdkupa: {
    path: "sif/tpStatusOdkupa",
    name: "Tp Status Odkupa",
    description:
      "[sif.tp_status_odkupa] Šifrant z zalogo vrednosti za različne statuse odkupa.",
  },
  SifTipPripusta: {
    path: "sif/tipPripusta",
    name: "Tip Pripusta",
    description: "[sif.tip_pripusta] Šifrant za različne tipe pripusta.",
  },
  SifTipMolze: {
    path: "sif/tipMolze",
    name: "Tip Molze",
    description:
      "[sif.tip_molze] Šifrant različnih tipov (načinov) molže (strojno, ročno...).",
  },
  SifTipIzracunaPasmeZivali: {
    path: "sif/tipIzracunaPasmeZivali",
    name: "Tip Izracuna Pasme Zivali",
    description: "[sif.tip_izracuna_pasme_zivali] Tip izračuna pasme živai",
  },
  SifTipIdentifikatorja: {
    path: "sif/tipIdentifikatorja",
    name: "Tip Identifikatorja",
    description:
      "[sif.tip_identifikatorja] Šifrant, ki vsebuje različne tipe identifikatorjev (Ušesna številka, SIŠ, Tatu...)",
  },
  SifTipGeneoloskePotrditve: {
    path: "sif/tipGeneoloskePotrditve",
    name: "Tip Geneoloske Potrditve",
    description:
      "[sif.tip_geneoloske_potrditve] Šifrant, ki vsebuje različne tipe, preko katerega lahko potrjujemo geneološke povezave (Genetska analiza, S tipom pripusta,...",
  },
  SifTehnologijaOdstavitveVTropu: {
    path: "sif/tehnologijaOdstavitveVTropu",
    name: "Tehnologija Odstavitve V Tropu",
    description:
      "[sif.tehnologija_odstavitve_v_tropu] Šifrant možnih vrednosti za tehnologijo odstavitve v tropu.",
  },
  SifStatusReje: {
    path: "sif/statusReje",
    name: "Status Reje",
    description: "[sif.status_reje] Šifrant z zalogo vrednosti za status reje",
  },
  SifStarsevstvo: {
    path: "sif/starsevstvo",
    name: "Starsevstvo",
    description:
      "[sif.starsevstvo] Šifrant z zalogo vrednosti za rezultate glede starševstva pri genotipizaciji.",
  },
  SifSpol: {
    path: "sif/spol",
    name: "Spol",
    description: "[sif.spol] Šifrant možnih spolov živali.",
  },
  SifSpecies: {
    path: "sif/species",
    name: "Species",
    description:
      "[sif.species] Species (Osnovni šifrant živalskih vrst) [sif.species].",
  },
  SifSnpAlel: {
    path: "sif/snpAlel",
    name: "Snp Alel",
    description:
      "[sif.snp_alel] Šifrant z zalogo vrednosti za različen SNP alele.",
  },
  SifSkupnaPlemenskaVrednost: {
    path: "sif/skupnaPlemenskaVrednost",
    name: "Skupna Plemenska Vrednost",
    description:
      "[sif.skupna_plemenska_vrednost] Šifrant, ki vsebuje zalogo vrednosti za skupno plemensko vrednost živali.",
  },
  SifSemeRazredcevalec: {
    path: "sif/semeRazredcevalec",
    name: "Seme Razredcevalec",
    description:
      "[sif.seme_razredcevalec] Šifrant razredčevalcev, ki se uporabljajo pri pripravi doz semena.",
  },
  SifSemeOcenaGostote: {
    path: "sif/semeOcenaGostote",
    name: "Seme Ocena Gostote",
    description: "[sif.seme_ocena_gostote] Subjektivna ocena gostote semena.",
  },
  SifSemeNacinPriprave: {
    path: "sif/semeNacinPriprave",
    name: "Seme Nacin Priprave",
    description:
      "[sif.seme_nacin_priprave] Šifrant načinov priprav doze semena.",
  },
  SifSemeLibido: {
    path: "sif/semeLibido",
    name: "Seme Libido",
    description:
      "[sif.seme_libido] Šifrant, ki vsebuje zalogo vrednosti za opisovanje libida samca.",
  },
  SifRodovniskaKnjigaRazred: {
    path: "sif/rodovniskaKnjigaRazred",
    name: "Rodovniska Knjiga Razred",
    description: "[sif.rodovniska_knjiga_razred] Razred rodovniške knjige.",
  },
  SifRodovniskaKnjigaRazdelek: {
    path: "sif/rodovniskaKnjigaRazdelek",
    name: "Rodovniska Knjiga Razdelek",
    description:
      "[sif.rodovniska_knjiga_razdelek] Šifrant, ki vsebuje vrednosti različne razdelke v rodovniških knjigah.",
  },
  SifRejnProgTipVstopa: {
    path: "sif/rejnProgTipVstopa",
    name: "Rejn Prog Tip Vstopa",
    description:
      "[sif.rejn_prog_tip_vstopa] Šifrant z zalogo vrednosti za različne tipe vstopov v rejne programe.",
  },
  SifRejnProgTipIzstopa: {
    path: "sif/rejnProgTipIzstopa",
    name: "Rejn Prog Tip Izstopa",
    description:
      "[sif.rejn_prog_tip_izstopa] Šifrant z zalogo vrednosti za različne tipe izstopov iz rejnih programov.",
  },
  SifRejnProgStatusRejca: {
    path: "sif/rejnProgStatusRejca",
    name: "Rejn Prog Status Rejca",
    description:
      "[sif.rejn_prog_status_rejca] Šifrant možnih vrednosti za različne statuse rejca v sklopu rejnih programov",
  },
  SifRejnProgStatusClanstva: {
    path: "sif/rejnProgStatusClanstva",
    name: "Rejn Prog Status Clanstva",
    description:
      "[sif.rejn_prog_status_clanstva] Šifrant z zalogo vrednosti za status članstva subjekta v rejnem programu",
  },
  SifProdajaSemenaRazlogPrepoved: {
    path: "sif/prodajaSemenaRazlogPrepoved",
    name: "Prodaja Semena Razlog Prepoved",
    description:
      "[sif.prodaja_semena_razlog_prepoved] Razlog za prepoved prodaje semena.",
  },
  SifPripustObnasanjeSamice: {
    path: "sif/pripustObnasanjeSamice",
    name: "Pripust Obnasanje Samice",
    description:
      "[sif.pripust_obnasanje_samice] Šifrant za obnašanje samice med pripustom/osemenjevanjem.",
  },
  SifPripustObnasanjeSamca: {
    path: "sif/pripustObnasanjeSamca",
    name: "Pripust Obnasanje Samca",
    description:
      "[sif.pripust_obnasanje_samice] Šifrant za obnašanje samca med pripustom/osemenjevanjem.",
  },
  SifPripustKondicijaSamice: {
    path: "sif/pripustKondicijaSamice",
    name: "Pripust Kondicija Samice",
    description:
      "[sif.pripust_kondicija_samice] Šifrant za opisovanje kondicije samice pri pripustu.",
  },
  SifPripustKondicijaSamca: {
    path: "sif/pripustKondicijaSamca",
    name: "Pripust Kondicija Samca",
    description:
      "[sif.pripust_kondicija_samca] Šifrant za opisovanje kondicije samice pri pripustu.",
  },
  SifPremikNamen: {
    path: "sif/premikNamen",
    name: "Premik Namen",
    description:
      "[sif.premik_namen] Šifrant z različnimi nameni, zaradi katerih se premik lahko izvede (prodaja, razmnoževanje..)",
  },
  SifPremikBrejost: {
    path: "sif/premikBrejost",
    name: "Premik Brejost",
    description:
      "[sif.premik_brejost] Šifrant, ki vsebuje vrednosti za brejost ob prodaji.",
  },
  SifPotekKotitve: {
    path: "sif/potekKotitve",
    name: "Potek Kotitve",
    description:
      "[sif.potek_kotitve] Skupni šifrant, ki označuje potek kotitve.",
  },
  SifPoreklo: {
    path: "sif/poreklo",
    name: "Poreklo",
    description:
      "[sif.poreklo] Šifrant, ki vsebuje zalogo vrednosti za različna porekla živali.",
  },
  SifPlemVredTipPv: {
    path: "sif/plemVredTipPv",
    name: "Plem Vred Tip Pv",
    description: "[sif.plem_vred_tip_pv] Šifrant z tipi plemenskih vrednosti.",
  },
  SifPlemVredMetodaIzracuna: {
    path: "sif/plemVredMetodaIzracuna",
    name: "Plem Vred Metoda Izracuna",
    description:
      "[sif.plem_vred_metoda_izracuna] Šifrant z metodami izračuna za plemenske vrednosti.",
  },
  SifPlemVredKodaPopulacije: {
    path: "sif/plemVredKodaPopulacije",
    name: "Plem Vred Koda Populacije",
    description:
      "[sif.plem_vred_koda_populacije] Šifrant z kodami populacije za plemenske vrednosti.",
  },
  SifPasmaStatus: {
    path: "sif/pasmaStatus",
    name: "Pasma Status",
    description:
      "[sif.pasma_status] Šifrant, ki vsebuje zalogo vrednosti, ki določajo stanje pasme.",
  },
  SifPasemskeZnacilnosti: {
    path: "sif/pasemskeZnacilnosti",
    name: "Pasemske Znacilnosti",
    description:
      "[sif.pasemske_znacilnosti] Šifrant, ki vsebuje zalogo vrednosti za pasemske značilnosti živali.",
  },
  SifOznakaGena: {
    path: "sif/oznakaGena",
    name: "Oznaka Gena",
    description:
      "[sif.oznaka_gena] Šifrant z zalogo vrednosti za različne oznake genov.",
  },
  SifOsnovnaBarva: {
    path: "sif/osnovnaBarva",
    name: "Osnovna Barva",
    description: "[sif.osnovna_barva] Šifrant različnih osnovnih barv.",
  },
  SifOcenaZunanjosti: {
    path: "sif/ocenaZunanjosti",
    name: "Ocena Zunanjosti",
    description:
      "[sif.ocena_zunanjosti] Šifrant, ki vsebuje zalogo vrednosti za ocenjevanje zunanjosti živali.",
  },
  SifNivoDostopa: {
    path: "sif/nivoDostopa",
    name: "Nivo Dostopa",
    description:
      "[sif.nivo_dostopa] Tabela z spiskom različnih nivojev dostopa (vlog) za kontekst zastopništev.",
  },
  SifNamenOdvzema: {
    path: "sif/namenOdvzema",
    name: "Namen Odvzema",
    description:
      "[sif.namen_odvzema] Šifrant različnih možnosti za namen odvzema vzorcev.",
  },
  SifNacinReje: {
    path: "sif/nacinReje",
    name: "Nacin Reje",
    description: "[sif.nacin_reje] Šifrant z vrednostmi za način reje.",
  },
  SifNacinOznacitve: {
    path: "sif/nacinOznacitve",
    name: "Nacin Oznacitve",
    description: "[sif.nacin_oznacitve] Šifrant načinov označitve živali.",
  },
  SifLaboratoriji: {
    path: "sif/laboratoriji",
    name: "Laboratoriji",
    description:
      "[sif_drob.element_pps] Šifrant 3.3.1.31\t  PPS element  - na testnih postajah (TP)",
  },
  SifKotitevTip: {
    path: "sif/kotitevTip",
    name: "Kotitev Tip",
    description:
      "[sif.kotitev_tip] Šifrant, ki vsebuje zalogo vrednosti za opisovanje tipa kotitve (normalna, abortus).",
  },
  SifKlavnice: {
    path: "sif/klavnice",
    name: "Klavnice",
    description:
      "[sif.klavnice] Šifrant, ki vsebuje zalogo vrednosti za možne klavnice.",
  },
  SifIzvajalec: {
    path: "sif/izvajalec",
    name: "Izvajalec",
    description:
      "[sif.izvajalec] Šifrant izvajalcev, ki lahko nek dogodek na terenu opravijo (izvedejo).",
  },
  SifIzvajalecOsemenjevanja: {
    path: "sif/izvajalecOsemenjevanja",
    name: "Izvajalec Osemenjevanja",
    description:
      "[sif.izvajalec_osemenjevanja] Šifrant za različne tipe izvajalecev osemenjevanja.",
  },
  SifIzidPripusta: {
    path: "sif/izidPripusta",
    name: "Izid Pripusta",
    description:
      "[sif.izid_pripusta] Šifrant z različnimi izidi pripusta (KOTITEV, ABORTUS, REABSORBCIJA, NEUSPELO...",
  },
  SifGenskoTestiranje: {
    path: "sif/genskoTestiranje",
    name: "Gensko Testiranje",
    description:
      "[sif.gensko_testiranje] Šifrant, ki vsebuje zalogo vrednosti za določanje načina opravljanja genskega testiranja.",
  },
  SifGenskiNabor: {
    path: "sif/genskiNabor",
    name: "Genski Nabor",
    description:
      "[sif.genski_nabor] Šifrant različnih naborov genov pri uvozu.",
  },
  SifDrzava: {
    path: "sif/drzava",
    name: "Drzava",
    description: "[sif.drzava] Podatki s področja: 3.3.4.1 Država",
  },
  SifDocxPlaceholderTip: {
    path: "sif/docxPlaceholderTip",
    name: "Docx Placeholder Tip",
    description: "[sif.docx_placeholder_tip] Šifrant z tipi DocX ključnikov.",
  },
  SifAplikacijaSemena: {
    path: "sif/aplikacijaSemena",
    name: "Aplikacija Semena",
    description:
      "[sif.aplikacija_semena] Podatki s področja: 3.3.3.15 Aplikacija semena",
  },
  SifSistZivalZgodovinaDogodek: {
    path: "sif/sist/zivalZgodovinaDogodek",
    name: "Zival Zgodovina Dogodek",
    description:
      "[sif_sist.zival_zgodovina_dogodek] Sistemski šifrant za različne dogodke nad živaljo.",
  },
  SifSistVnosTipUvoza: {
    path: "sif/sist/vnosTipUvoza",
    name: "Vnos Tip Uvoza",
    description:
      "[sif_sist.vnos_tip_uvoza] Šifrant z možnimi tipi vnosa (UVOZ, SEME, IZVEN_KONTROLE)",
  },
  SifSistStatusVnosnegaZapisa: {
    path: "sif/sist/statusVnosnegaZapisa",
    name: "Status Vnosnega Zapisa",
    description:
      "[sif_sist.status_vnosnega_zapisa] Šifrant z možnimi statusi za vnosne zapise živali.",
  },
  SifDrobUsoda: {
    path: "sif/drob/usoda",
    name: "Usoda",
    description:
      "[sif_drob.usoda] Šifrant, ki vsebuje dovoljene vnosne vrednosti za usodo ob označitvi.",
  },
  SifDrobTipKrvneAnalize: {
    path: "sif/drob/tipKrvneAnalize",
    name: "Tip Krvne Analize",
    description:
      "[sif_drob.tip_krvne_analize] Šifrant z različnimi tipi krvne analize.",
  },
  SifDrobTestiranOcenjen: {
    path: "sif/drob/testiranOcenjen",
    name: "Testiran Ocenjen",
    description:
      "Status, ali je bil postopek opravljen.   Šifrant Testiran/ocenjen 3.3.1.25",
  },
  SifDrobTemperament: {
    path: "sif/drob/temperament",
    name: "Temperament",
    description:
      "Ocenjen značaj živali.   Šifrant vrednosti telesnih ocen 3.3.1.23",
  },
  SifDrobTelesOcene: {
    path: "sif/drob/telesOcene",
    name: "Teles Ocene",
    description: "Šifrant telesnih ocen.",
  },
  SifDrobTelesOceneOpisno: {
    path: "sif/drob/telesOceneOpisno",
    name: "Teles Ocene Opisno",
    description:
      "Subjektivna ocena komisije (1A-3B) oz kakovostna ocena.    Šifrant opisnih telesnih ocen 3.3.1.20",
  },
  SifDrobTelesOceneLastnosti: {
    path: "sif/drob/telesOceneLastnosti",
    name: "Teles Ocene Lastnosti",
    description: "Opisne lastnosti telesnih ocen.",
  },
  SifDrobTelesOceneIzenacenost: {
    path: "sif/drob/telesOceneIzenacenost",
    name: "Teles Ocene Izenacenost",
    description:
      "[sif_drob.teles_ocene_izenacenost] Šifrant z zalogo vrednosti za izenačenost v povezavi z neko telesno oceno.",
  },
  SifDrobStatusOdkupDokument: {
    path: "sif/drob/statusOdkupDokument",
    name: "Status Odkup Dokument",
    description:
      "[sif.status_odkup_dokument] Šifrant z različnimi statusi dokumenta za odkup.",
  },
  SifDrobSemeCelice: {
    path: "sif/drob/semeCelice",
    name: "Seme Celice",
    description:
      "[sif_drob.seme_celice] Šifrant, ki vsebuje zalogo vrednosti za zajem semena na TP.",
  },
  SifDrobRojenKot: {
    path: "sif/drob/rojenKot",
    name: "Rojen Kot",
    description: "[sif_drob.rojen_kot] Šifrant različnih vrst tipov rojstev.",
  },
  SifDrobRogatost: {
    path: "sif/drob/rogatost",
    name: "Rogatost",
    description:
      "[sif_drob.rogatost] Šifrant, ki vsebuje dovoljene vnosne vrednosti za opisovanje rogatosti.",
  },
  SifDrobPpsElement: {
    path: "sif/drob/ppsElement",
    name: "Pps Element",
    description:
      "[sif_drob.element_pps] Šifrant 3.3.1.31\t  PPS element  - na testnih postajah (TP)",
  },
  SifDrobOstrizen: {
    path: "sif/drob/ostrizen",
    name: "Ostrizen",
    description:
      "Informacija o  poraščenosti z volno v času ocenjevanja živali (ostrižen, neostrižen).   Šfrant Ostrižen 3.3.1.24",
  },
  SifDrobKakovostniRazred: {
    path: "sif/drob/kakovostniRazred",
    name: "Kakovostni Razred",
    description:
      "[sif_drob.element_pps] Šifrant 3.3.1.31\t  PPS element  - na testnih postajah (TP)",
  },
  SifDrobFinostVolne: {
    path: "sif/drob/finostVolne",
    name: "Finost Volne",
    description:
      "[sif_drob.finost_volne] Šifrant različnih možnosti za finost volne pri drobnici.",
  },
  SifDrobDobraMati: {
    path: "sif/drob/dobraMati",
    name: "Dobra Mati",
    description:
      "[sif.dobra_mati] Šifrant z vrednostmi ali je bila mati dobra ali ne.",
  },
  SifDrobBolezenRezultatTesta: {
    path: "sif/drob/bolezenRezultatTesta",
    name: "Bolezen Rezultat Testa",
    description:
      "[sif.bolezen_rezultat_testa] Šifrant z različnimi možnostmi za rezultat testa.",
  },
  SifDrobBarvaDrobnice: {
    path: "sif/drob/barvaDrobnice",
    name: "Barva Drobnice",
    description:
      "[sif_drob.barva_drobnice] Šifrant, ki vsebuje dovoljene vnosne vrednosti za barvo drobnice.",
  },
  SifPraVrstaPlemMeritev: {
    path: "sif/pra/vrstaPlemMeritev",
    name: "Vrsta Plem Meritev",
    description:
      "[sif_pra.vrsta_plem_meritev] Šifrant z zalogo vrednosti za različne vrste meritev pri preizkusu podmladka.",
  },
  SifPraTrupNacinObdelave: {
    path: "sif/pra/trupNacinObdelave",
    name: "Trup Nacin Obdelave",
    description:
      "[sif_pra.trup_nacin_obdelave] Šifrant, ki vsebuje zalogo vrednosti za način obdelave trupa v klavnici.",
  },
  SifPraTipPlemPreizkusa: {
    path: "sif/pra/tipPlemPreizkusa",
    name: "Tip Plem Preizkusa",
    description:
      "[sif_pra.tip_plem_preizkusa] Šifrant z zalogo vrednosti za različne tipe plemenskega preizkusa.",
  },
  SifPraStatusPreizkusaPodmladka: {
    path: "sif/pra/statusPreizkusaPodmladka",
    name: "Status Preizkusa Podmladka",
    description:
      "[sif_pra.status_preizkusa_podmladka] Šifrant z zalogo vrednosti za različne statuse preizkusa plemenskega podmladka.",
  },
  SifPraNamenRabe: {
    path: "sif/pra/namenRabe",
    name: "Namen Rabe",
    description:
      "[sif_pra.namen_rabe] Šifrant z zalogo vrednosti za različne namene rabe prašičev.",
  },
  SifPraNamenProdaje: {
    path: "sif/pra/namenProdaje",
    name: "Namen Prodaje",
    description: "[sif_pra.namen_prodaje] Namen prodaje prašiča.",
  },
  SifPraKategorijaKlavnihTrupov: {
    path: "sif/pra/kategorijaKlavnihTrupov",
    name: "Kategorija Klavnih Trupov",
    description:
      "[sif_pra.kategorija_klavnih_trupov] Šifrant, ki vsebuje zalogo vrednosti za kategorije klavnih trupov.",
  },
  SifPraIzidPreizkusaPlemPodmladka: {
    path: "sif/pra/izidPreizkusaPlemPodmladka",
    name: "Izid Preizkusa Plem Podmladka",
    description:
      "[sif_pra.izid_preizkusa_plem_podmladka] Šifrant z zalogo vrednosti za različne izide preizkusa plemenskega podmladka.",
  },
  SifPraDodatnaOznakaPujska: {
    path: "sif/pra/dodatnaOznakaPujska",
    name: "Dodatna Oznaka Pujska",
    description:
      "[sif_pra.dodatna_oznaka_pujska] Dodatna oznaka pujska ob označitvi.",
  },
  SifPraBrejostObProdaji: {
    path: "sif/pra/brejostObProdaji",
    name: "Brejost Ob Prodaji",
    description:
      "[sif_pra.brejost_ob_prodaji] Rezultati pregledov na brejost ob prodaji.",
  },
  SifPraBarvaPrasicev: {
    path: "sif/pra/barvaPrasicev",
    name: "Barva Prasicev",
    description:
      "[sif_pra.barva_prasicev] Šifrant, ki vsebuje dovoljene vnosne vrednosti za opisovanje obarvanosti prašičev.",
  },
  SifKopZnamenja: {
    path: "sif/kop/znamenja",
    name: "Znamenja",
    description: "[sif_kop.znamenja] Šifrant različnih možnosti za znamenja.",
  },
  SifKopZnamenjaTrup: {
    path: "sif/kop/znamenja/trup",
    name: "Znamenja Trup",
    description:
      "[sif_kop.znamenja_trup] Šifrant znamenj trupa kopitarjev (PZI 3.3.2.31).",
  },
  SifKopZnamenjaNoge: {
    path: "sif/kop/znamenja/noge",
    name: "Znamenja Noge",
    description:
      "[sif_kop.znamenja_noge] Šifrant znamenj nog kopitarjev (PZI 3.3.2.28).",
  },
  SifKopZnamenjaGlava: {
    path: "sif/kop/znamenja/glava",
    name: "Znamenja Glava",
    description:
      "[sif_kop.znamenja_glava] Šifrant znamenj glave kopitarjev (PZI 3.3.2.22).",
  },
  SifKopZnacilnostiTrup: {
    path: "sif/kop/znacilnosti/trup",
    name: "Znacilnosti Trup",
    description:
      "[sif_kop.znacilnosti_trup] Šifrant značilnosti trupa kopitarjev (PZI 3.3.2.33).",
  },
  SifKopZnacilnostiNoge: {
    path: "sif/kop/znacilnosti/noge",
    name: "Znacilnosti Noge",
    description:
      "[sif_kop.znacilnosti_noge] Šifrant značilnosti nog kopitarjev (PZI 3.3.2.27).",
  },
  SifKopZnacilnostiGlava: {
    path: "sif/kop/znacilnosti/glava",
    name: "Znacilnosti Glava",
    description:
      "[sif_kop.znacilnosti_glava] Šifrant značilnosti glave kopitarjev (PZI 3.3.2.24).",
  },
  SifKopZnacilnost: {
    path: "sif/kop/znacilnost",
    name: "Znacilnost",
    description:
      "[sif_kop.znacilnost] Šifrant različnih možnosti za značilnosti (neke lastnosti) na kopitarju.",
  },
  SifKopZigTip: {
    path: "sif/kop/zig/tip",
    name: "Zig Tip",
    description:
      "[sif_kop.zig_tip] Šifrant različnih možnosti za žige (znamenja) na kopitarju.",
  },
  SifKopZigSlika: {
    path: "sif/kop/zig/slika",
    name: "Zig Slika",
    description:
      "[sif_kop.zig_slika] Šifrant različnih možnosti slike žiga (znamenja) na kopitarju.",
  },
  SifKopZigPolozaj: {
    path: "sif/kop/zig/polozaj",
    name: "Zig Polozaj",
    description:
      "[sif_kop.zig_polozaj] Šifrant različnih možnosti za položajev žiga (znamenja) na kopitarju.",
  },
  SifKopVzorecGrive: {
    path: "sif/kop/vzorecGrive",
    name: "Vzorec Grive",
    description:
      "[sif_kop.vzorec_grive] Šifrant različnih možnosti za vzorce griv.",
  },
  SifKopVrtinecOblika: {
    path: "sif/kop/vrtinec/oblika",
    name: "Vrtinec Oblika",
    description: "[sif_kop.vrtinec_oblika] Šifrant oblik vrtinca kopitarjev.",
  },
  SifKopVrtinciTrup: {
    path: "sif/kop/vrtinci/trup",
    name: "Vrtinci Trup",
    description: "[sif_kop.vrtinci_trup] Šifrant vrtincev trupa kopitarjev.",
  },
  SifKopVrtinciGlava: {
    path: "sif/kop/vrtinci/glava",
    name: "Vrtinci Glava",
    description: "[sif_kop.vrtinci_glava] Šifrant vrtincev glave kopitarjev.",
  },
  SifKopVrstaPrepovedi: {
    path: "sif/kop/vrstaPrepovedi",
    name: "Vrsta Prepovedi",
    description:
      "[sif_kop.vrsta_prepovedi] Šifrant različnih prepovedi dogodkov oziroma procesov pri kopitarjih.",
  },
  SifKopVrstaIdentifikacijskegaDokumenta: {
    path: "sif/kop/vrstaIdentifikacijskegaDokumenta",
    name: "Vrsta Identifikacijskega Dokumenta",
    description:
      "[sif_kop.vrsta_identifikacijskega_dokumenta] Šifrant različnih tipov identifikacijskih dokumentov.",
  },
  SifKopTipDelovnegaPreizkusa: {
    path: "sif/kop/tipDelovnegaPreizkusa",
    name: "Tip Delovnega Preizkusa",
    description:
      "[sif_kop.tip_delovnega_preizkusa] Tip preizkusa delovne sposobnosti.",
  },
  SifKopStanjeKobile: {
    path: "sif/kop/stanjeKobile",
    name: "Stanje Kobile",
    description:
      "[sif_kop.stanje_kobile] Šifrant različnih možnosti za  stanje kobile (po žrebitvi).",
  },
  SifKopRod: {
    path: "sif/kop/rod",
    name: "Rod",
    description: "[sif_kop.rod] Šifrant rodov kopitarjev (PZI 3.3.2.7).",
  },
  SifKopPripustnaPostajaOcene: {
    path: "sif/kop/pripustnaPostajaOcene",
    name: "Pripustna Postaja Ocene",
    description:
      "[sif_kop.pripustna_postaja_ocene] Šifrant različnih ocen elementov pripustne postaje.",
  },
  SifKopPolozaj: {
    path: "sif/kop/polozaj",
    name: "Polozaj",
    description:
      "[sif_kop.polozaj] Šifrant različnih možnosti za položaje (nečesa) na kopitarju.",
  },
  SifKopPolozajTrup: {
    path: "sif/kop/polozaj/trup",
    name: "Polozaj Trup",
    description:
      "[sif_kop.polozaj_trup] Šifrant položajev trupa kopitarjev (PZI 3.3.2.32).",
  },
  SifKopPolozajNoge: {
    path: "sif/kop/polozaj/noge",
    name: "Polozaj Noge",
    description:
      "[sif_kop.polozaj_noge] Šifrant položajev nog kopitarjev (PZI 3.3.2.26).",
  },
  SifKopPolozajGlava: {
    path: "sif/kop/polozaj/glava",
    name: "Polozaj Glava",
    description:
      "[sif_kop.polozaj_glava] Šifrant položajev glave kopitarjev (PZI 3.3.2.23).",
  },
  SifKopOdtenekGrive: {
    path: "sif/kop/odtenekGrive",
    name: "Odtenek Grive",
    description:
      "[sif_kop.odtenek_grive] Šifrant različnih možnosti za odtenke griv.",
  },
  SifKopOblika: {
    path: "sif/kop/oblika",
    name: "Oblika",
    description:
      "[sif_kop.oblika] Šifrant različnih možnosti za oblike (nečesa) na kopitarju.",
  },
  SifKopOblikaTrup: {
    path: "sif/kop/oblika/trup",
    name: "Oblika Trup",
    description:
      "[sif_kop.oblika_trup] Šifrant oblik trupa kopitarjev (PZI 3.3.2.34).",
  },
  SifKopOblikaNoge: {
    path: "sif/kop/oblika/noge",
    name: "Oblika Noge",
    description:
      "[sif_kop.oblika_noge] Šifrant oblik nog kopitarjev (PZI 3.3.2.29).",
  },
  SifKopOblikaGlava: {
    path: "sif/kop/oblika/glava",
    name: "Oblika Glava",
    description:
      "[sif_kop.oblika_glava] Šifrant oblik glave kopitarjev (PZI 3.3.2.25).",
  },
  SifKopNapakeVrstaNapake: {
    path: "sif/kop/napake/vrstaNapake",
    name: "Napake Vrsta Napake",
    description:
      "[sif_kop.napake_vrsta_napake] Šifrant različnih možnosti za lastnost (vrsto zunanje napake) na kopitarju.",
  },
  SifKopNapakeStopnjaNapake: {
    path: "sif/kop/napake/stopnjaNapake",
    name: "Napake Stopnja Napake",
    description:
      "[sif_kop.napake_stopnja_napake] Šifrant različnih možnosti za stopnjo napake na kopitarju.",
  },
  SifKopNapakeNacinPridobitve: {
    path: "sif/kop/napake/nacinPridobitve",
    name: "Napake Nacin Pridobitve",
    description:
      "[sif_kop.napake_nacin_pridobitve] Šifrant različnih možnosti za način pridobitve napake na kopitarju.",
  },
  SifKopLinija: {
    path: "sif/kop/linija",
    name: "Linija",
    description: "[sif_kop.linija] Šifrant linij kopitarjev (PZI 3.3.2.5).",
  },
  SifKopKondicijaSamca: {
    path: "sif/kop/kondicijaSamca",
    name: "Kondicija Samca",
    description:
      "[sif_kop.kondicija_samca] Šifrant različnih možnosti za kondicijo samca pri pregledu.",
  },
  SifKopIzdajatelj: {
    path: "sif/kop/izdajatelj",
    name: "Izdajatelj",
    description:
      "[sif_kop.izdajatelj] Šifrant možnih izdajateljev (kopitarji).",
  },
  SifKopBarvaGrive: {
    path: "sif/kop/barvaGrive",
    name: "Barva Grive",
    description:
      "[sif_kop.barva_grive] Barva grive - zaloga vrednosti za barvo griv kopitarjev.",
  },
  SifKopBarvaNoge: {
    path: "sif/kop/barva/noge",
    name: "Barva Noge",
    description:
      "[sif_kop.barva_noge] Šifrant barv nog kopitarjev (PZI 3.3.2.30).",
  },
});

export default def;
